(() => {
  'use strict';
  if (window.ITPCommerceV14) { window.ITPCommerceV14.refresh(); return; }
  const controllers = new Map();
  const prepareDescription = description => {
    if (!description || !description.querySelector('h1')) return;
    const headingToken = /(^|[\s>+~,(])h1(?=$|[\s>+~.#\[:),])/gi;
    const headingRules = rules => [...rules].map(rule => {
      if (rule.selectorText) {
        const selector = rule.selectorText.replace(headingToken, '$1[data-commerce-description-heading]');
        return selector === rule.selectorText ? '' : `${selector}{${rule.style.cssText}}`;
      }
      if (!rule.cssRules) return '';
      const children = headingRules(rule.cssRules);
      return children ? `${rule.cssText.slice(0, rule.cssText.indexOf('{'))}{${children}}` : '';
    }).join('\n');
    // Merchant descriptions sometimes contain a complete landing page. Preserve
    // its own heading styles while keeping the product title as the page H1.
    const styles = [...description.querySelectorAll('style')].map(style => {
      try { return style.sheet ? headingRules(style.sheet.cssRules) : ''; } catch { return ''; }
    }).filter(Boolean).join('\n');
    if (styles) {
      const style = document.createElement('style');
      style.dataset.commerceDescriptionStyles = '';
      style.textContent = styles;
      description.append(style);
    }
    description.querySelectorAll('h1').forEach(heading => {
      const replacement = document.createElement('h2');
      for (const attribute of heading.attributes) if (!attribute.name.startsWith('data-cinema15-')) replacement.setAttribute(attribute.name, attribute.value);
      replacement.dataset.commerceDescriptionHeading = '';
      replacement.append(...[...heading.childNodes].map(node => node.cloneNode(true)));
      replacement.querySelectorAll('.cinema15-word-shell').forEach(shell => shell.replaceWith(...(shell.firstElementChild || shell).childNodes));
      heading.replaceWith(replacement);
    });
  };
  const initialize = root => {
    if (controllers.has(root) || typeof AbortController !== 'function') return;
    const source = root.querySelector('[data-commerce-variants]');
    if (!source) return;
    let variants;
    try {
      const rows = JSON.parse(source.textContent);
      if (!Array.isArray(rows) || rows.some(row => !row || !/^[0-9]+$/.test(String(row.id)) || typeof row.price !== 'string' || !Array.isArray(row.plans))) return;
      variants = new Map(rows.map(row => [String(row.id), row]));
    } catch { return; }
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const select = root.querySelector('[data-commerce-variant-select]');
    const variantInput = root.querySelector('[data-commerce-variant-id]');
    const quantity = root.querySelector('[data-commerce-quantity]');
    const add = root.querySelector('[data-commerce-add]');
    const label = root.querySelector('[data-commerce-add-text]');
    const price = root.querySelector('[data-commerce-price]');
    const compare = root.querySelector('[data-commerce-compare]');
    const unit = root.querySelector('[data-commerce-unit]');
    const status = root.querySelector('[data-commerce-status]');
    const plan = root.querySelector('[data-commerce-plan]');
    const planWrap = root.querySelector('[data-commerce-plan-wrap]');
    const gallery = root.querySelector('[data-commerce-media-gallery]');
    const description = root.querySelector('[data-commerce-description]');
    prepareDescription(description);
    if (!variantInput || !quantity || !add || !price || !compare || !status || !plan || !planWrap) return;
    const requiresPlan = plan.dataset.required === 'true';
    let current = variants.get(String(select?.value || variantInput.value));
    const cartAddPath = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/add\/?$/;
    let nativeAction = null;
    try {
      const action = variantInput.form && new URL(variantInput.form.action, location.href);
      if (action?.origin === location.origin && cartAddPath.test(action.pathname)) nativeAction = action;
    } catch {}
    const embedded = [...(description?.querySelectorAll('form.itp-order-form') || [])].flatMap(form => {
      const radios = [...form.querySelectorAll('input[type="radio"][name="id"]')];
      try {
        const action = new URL(form.action, location.href);
        if (form.method.toLowerCase() !== 'post' || action.origin !== location.origin || !cartAddPath.test(action.pathname) || form.querySelector('[name="selling_plan"]') || !radios.length || !radios.every(radio => variants.has(radio.value))) return [];
      } catch { return []; }
      if (nativeAction) form.setAttribute('action', nativeAction.pathname + nativeAction.search);
      return [{ form, radios, quantity: form.querySelector('[name="quantity"]'), submit: form.querySelector('[type="submit"]') }];
    });
    function syncEmbedded() {
      for (const record of embedded) {
        record.radios.forEach(radio => {
          const variant = variants.get(radio.value);
          radio.checked = radio.value === String(current?.id);
          radio.disabled = !variant.available;
          if (Number.isFinite(variant.amount)) radio.dataset.price = String(variant.amount);
          const amount = radio.closest('label')?.querySelector('b');
          if (amount) amount.textContent = variant.compactPrice || variant.price;
        });
        if (record.quantity) {
          record.quantity.value = quantity.value;
          for (const attribute of ['min', 'max', 'step']) {
            if (quantity.hasAttribute(attribute)) record.quantity.setAttribute(attribute, quantity.getAttribute(attribute));
            else record.quantity.removeAttribute(attribute);
          }
        }
        if (record.submit) {
          record.submit.disabled = add.disabled;
          const text = record.submit.querySelector('[data-itp-submit-label]');
          if (text) text.textContent = label?.textContent || root.dataset.addLabel;
        }
        const selected = record.radios.find(radio => radio.checked);
        const story = record.form.closest('#itp-disconnect-story') || record.form;
        story.querySelectorAll('[data-itp-order-size],[data-dc-selected-size]').forEach(node => { node.textContent = selected?.dataset.size || ''; });
        story.querySelectorAll('[data-itp-order-price],[data-dc-price]').forEach(node => { node.textContent = price.textContent; });
        let mirror = record.form.querySelector('input[data-commerce-plan-mirror]');
        if (!mirror) {
          mirror = document.createElement('input'); mirror.type = 'hidden'; mirror.name = 'selling_plan'; mirror.dataset.commercePlanMirror = ''; record.form.append(mirror);
        }
        mirror.value = plan.value;
        mirror.disabled = !current?.plans.some(item => String(item.id) === plan.value);
      }
    }
    let requestedPlan = null;
    try { requestedPlan = new URL(location.href).searchParams.get('selling_plan'); } catch {}
    const syncURL = (includeVariant = true) => {
      try {
        const url = new URL(location.href);
        if (includeVariant && current) {
          url.searchParams.set('variant', String(current.id));
          url.searchParams.delete('option_values');
        }
        if (current?.plans.some(item => String(item.id) === plan.value)) url.searchParams.set('selling_plan', plan.value);
        else url.searchParams.delete('selling_plan');
        history.replaceState(history.state, '', url);
      } catch {}
    };
    const setCompare = text => { compare.textContent = text || ''; compare.hidden = !text; };
    const updateQuantity = variant => {
      const minimum = Math.max(1, Number(variant.min) || 1);
      const step = Math.max(1, Number(variant.step) || 1);
      const maximum = variant.max == null ? Infinity : Number(variant.max);
      quantity.min = String(minimum);
      quantity.step = String(step);
      if (Number.isFinite(maximum)) quantity.max = String(maximum);
      else quantity.removeAttribute('max');
      const wanted = Math.max(minimum, Number(quantity.value) || minimum);
      const aligned = minimum + Math.max(0, Math.ceil((wanted - minimum) / step)) * step;
      const limit = Number.isFinite(maximum) ? minimum + Math.floor((maximum - minimum) / step) * step : Infinity;
      quantity.value = String(Math.max(minimum, Math.min(aligned, limit)));
      return maximum >= minimum;
    };
    const refreshPrice = () => {
      const allocation = current?.plans.find(item => String(item.id) === plan.value);
      const missingPlan = requiresPlan && !allocation;
      price.textContent = missingPlan ? root.dataset.planLabel : allocation?.price || current?.price || root.dataset.selectLabel;
      setCompare(missingPlan ? '' : allocation?.compare || (allocation ? '' : current?.compare));
      if (unit) { unit.textContent = allocation ? '' : current?.unit || ''; unit.hidden = !unit.textContent || missingPlan; }
      const canPurchase = !!current?.available && !missingPlan && updateQuantity(current);
      add.disabled = !canPurchase;
      if (label) label.textContent = !current ? root.dataset.selectLabel : !current.available ? root.dataset.soldLabel : missingPlan ? root.dataset.planLabel : root.dataset.addLabel;
      status.textContent = !current ? root.dataset.selectLabel : !current.available ? root.dataset.unavailableLabel : missingPlan ? root.dataset.planLabel : root.dataset.availableLabel;
      syncEmbedded();
    };
    const replacePlans = (preferred = plan.value) => {
      const fragment = document.createDocumentFragment();
      const empty = document.createElement('option');
      empty.value = '';
      empty.textContent = requiresPlan ? root.dataset.planLabel : root.dataset.onceLabel;
      empty.disabled = requiresPlan;
      fragment.append(empty);
      for (const allocation of current?.plans || []) {
        const option = document.createElement('option');
        option.value = String(allocation.id);
        option.textContent = `${allocation.name} · ${allocation.price}`;
        fragment.append(option);
      }
      plan.replaceChildren(fragment);
      plan.value = current?.plans.some(item => String(item.id) === preferred) ? preferred : '';
      planWrap.hidden = !current?.plans.length;
      plan.disabled = !current?.plans.length;
      plan.required = requiresPlan && !!current?.plans.length;
    };
    const changeVariant = id => {
      const next = variants.get(String(id));
      if (!next) return;
      current = next;
      if (select) select.value = String(next.id);
      variantInput.value = String(next.id);
      replacePlans();
      refreshPrice();
      if (gallery && next.media != null) {
        const media = [...gallery.querySelectorAll('[data-commerce-media]')].find(node => node.dataset.commerceMedia === String(next.media));
        if (media && gallery.firstElementChild !== media) {
          gallery.querySelectorAll('.commerce14-media--primary').forEach(node => node.classList.remove('commerce14-media--primary'));
          media.classList.add('commerce14-media--primary');
          media.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
          gallery.prepend(media);
        }
      }
      syncURL();
    };
    select?.addEventListener('change', () => changeVariant(select.value), options);
    plan.addEventListener('change', () => { refreshPrice(); syncURL(); }, options);
    const copyQuantity = (value, source = null) => {
      quantity.value = value;
      for (const record of embedded) if (record.quantity && record.quantity !== source) record.quantity.value = value;
    };
    quantity.addEventListener('input', () => copyQuantity(quantity.value), { ...options, capture: true });
    quantity.addEventListener('change', () => { if (current) updateQuantity(current); syncEmbedded(); }, { ...options, capture: true });
    for (const record of embedded) {
      record.quantity?.addEventListener('input', () => copyQuantity(record.quantity.value, record.quantity), { ...options, capture: true });
      record.quantity?.addEventListener('change', () => {
        quantity.value = record.quantity.value;
        if (current) updateQuantity(current);
        syncEmbedded();
      }, { ...options, capture: true });
      record.form.addEventListener('change', event => {
        if (record.radios.includes(event.target) && event.target.checked) changeVariant(event.target.value);
      }, options);
      record.form.addEventListener('submit', event => {
        const selected = record.radios.find(radio => radio.checked);
        if (!selected || !variants.get(selected.value)?.available) { event.preventDefault(); syncEmbedded(); return; }
        if (selected.value !== String(current?.id)) changeVariant(selected.value);
        if (record.quantity && current) { quantity.value = record.quantity.value; updateQuantity(current); }
        syncEmbedded();
        if (add.disabled || !record.form.checkValidity()) { event.preventDefault(); record.form.reportValidity(); }
      }, { ...options, capture: true });
    }
    window.addEventListener('pageshow', () => queueMicrotask(() => { if (!controller.signal.aborted) syncEmbedded(); }), options);
    if (current) {
      replacePlans(requestedPlan === null ? plan.value : requestedPlan);
      refreshPrice();
      if (requestedPlan !== null) syncURL(false);
    }
    const apply = root.querySelector('[data-commerce-variant-apply]');
    if (apply) apply.hidden = true;
    root.dataset.commerceEnhanced = 'true';
    controllers.set(root, controller);
  };
  const scan = scope => {
    if (scope.matches?.('[data-commerce14]')) initialize(scope);
    scope.querySelectorAll?.('[data-commerce14]').forEach(initialize);
    for (const [root, controller] of controllers) if (!root.isConnected) { controller.abort(); controllers.delete(root); }
  };
  window.ITPCommerceV14 = { refresh: () => scan(document) };
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, controller] of controllers) if (event.target === root || event.target.contains(root)) { controller.abort(); controllers.delete(root); }
  });
  scan(document);
})();

